import sortedIndexBy from 'lodash/sortedIndexBy';

// Mutates pre-sorted array to insert item at sorted position.
// 'iteratee' is a function that returns the value to use to compare items.
// Returns whether the array was modified.
export default function insertionSortUnique(array, item, iteratee) {
  let index = sortedIndexBy(array, item, iteratee);
  if (index >= array.length || iteratee(array[index]) !== iteratee(item)) {
    array.splice(index, 0, item);
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/utils/insertionSortUnique.js